import Head from "next/head";
import { useRouter } from "next/compat/router";

import { useSwrGet } from "@fwa/src/hooks/useSwrGet";
import { fwsUrlTeamSlug } from "@fwa/src/services/teamService";
import { JoinPage } from "@fwa/src/components/JoinPage";
import { ErrorPageWrapper } from "@fwa/src/components/ErrorPageWrapper";

import { type TeamPageType } from "@fwa/src/types";
import { queryAsString } from "@fwa/src/utils/urlUtils";

const Page = () => {
  const router = useRouter();
  const { slug } = router?.query || {};
  const slugString = queryAsString(slug);
  const url = slugString.length
    ? `${fwsUrlTeamSlug({ slug: slugString })}`
    : null;
  const { data: pageData, error } = useSwrGet<TeamPageType>(url);
  const themeName = pageData
    ? pageData?.theme ||
      pageData?.teamLeaderPage?.fundraisingPageType?.brand?.name
    : undefined;

  return (
    <ErrorPageWrapper error={error!}>
      {pageData ? (
        <>
          <Head>
            <title>Join {pageData.title}</title>
            <meta name="robots" content="noindex" />
          </Head>
          <JoinPage pageData={pageData} themeName={themeName} />
        </>
      ) : null}
    </ErrorPageWrapper>
  );
};

export default Page;
